import { Observable, catchError, noop, tap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../environments/environment';
import { TicketCountByStatus, TicketReplay, TicketSystem, } from '../models/interfaces/tieckets-system';
import { IResponse } from '../models/interfaces/response.model';
import { SideMenuService } from './../../admin/src/app/components/layout/side-menu/services/side-menu.service';
@Injectable({
  providedIn: 'root',
})
export class TicketSystemService {

  url = env.apiUrl + 'tickets';
  constructor(
    private http: HttpClient,
    private sideMenuService: SideMenuService
  ) {

  }
  createTickets(ticket: TicketSystem): Observable<TicketSystem> {
    return this.http.post<TicketSystem>(`${this.url}`, ticket);
  }

  // for admin
  getTickets(param: {} = {}): Observable<IResponse<TicketSystem>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<TicketSystem>>(`${this.url}?${params}`);
  }
  getTicket(id: any): Observable<TicketSystem> {
    return this.http.get<TicketSystem>(`${this.url}/${id}`);
  }
  // for user
  userTickets(param: {} = {}): Observable<IResponse<TicketSystem>> {
    const params = new HttpParams({ fromObject: param })
    return this.http.get<IResponse<TicketSystem>>(
      `${this.url}/user-tickets?${params}`
    );
  }
  userTicket(id: string): Observable<TicketSystem> {
    return this.http
      .get<TicketSystem>(`${this.url}/user-tickets/${id}`)
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }
  // admin and user
  deleteTicket(id: any): Observable<TicketSystem> {
    return this.http.delete<TicketSystem>(`${this.url}/${id}`);
  }
  closeTicket(ticketId: string): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/close-ticket/${ticketId}`,
      {}
    );
  }
  closeAdminTicket(ticketId: string): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/change-ticket-status/${ticketId}?status=Closed`,
      {}
    );
  }

  replyTicket(ticketId: string, replay: any): Observable<TicketReplay> {
    return this.http.post<TicketReplay>(
      `${this.url}/admin/add-ticket-reply/${ticketId}`,
      replay
    );
  }
  replyUserTicket(ticketId: string, replay: any): Observable<TicketReplay> {
    return this.http.post<TicketReplay>(
      `${this.url}/add-ticket-reply/${ticketId}`,
      replay
    );
  }

  getTicketReplies(ticketId: string, query = ''): Observable<TicketReplay[]> {
    return this.http.get<TicketReplay[]>(
      `${this.url}/ticket-replies/${ticketId}${query}`
    );
  }

  updateTicketReply(replayId: string, newReplay: TicketReplay): Observable<TicketReplay> {
    return this.http.patch<TicketReplay>(
      `${this.url}//update-ticket-reply//${replayId}`,
      newReplay
    );
  }

  changeTicketStatus(id: any, statusQuery = ''): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/change-ticket-status/${id}${statusQuery}`,{}
    );
  }

  countByStatus(): Observable<TicketCountByStatus> {
    return this.http.get<TicketCountByStatus>(`${this.url}/count-by-status`);
  }

  getCountByStatus() {
    this.countByStatus().pipe( tap(
      counts => {
        this.sideMenuService.ticketCount_BS.next(counts.open);
      }
    )).subscribe( noop );
  }

}
